var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrCrossCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-cross-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.576,
    height: 22.576,
    viewBox: "0 0 22.576 22.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6145",
    "data-name": "Path 6145",
    d: "M15.508,7.983a.941.941,0,0,0-1.33,0l-2.433,2.433L9.313,7.983a.941.941,0,1,0-1.33,1.33l2.433,2.432L7.983,14.178a.941.941,0,1,0,1.33,1.33l2.432-2.433,2.433,2.433a.941.941,0,1,0,1.33-1.33l-2.433-2.432,2.433-2.433A.941.941,0,0,0,15.508,7.983Z",
    transform: "translate(-0.457 -0.457)",
    fill: "#fc7886"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6146",
    "data-name": "Path 6146",
    d: "M11.288,0A11.288,11.288,0,1,0,22.576,11.288,11.288,11.288,0,0,0,11.288,0Zm0,20.695a9.407,9.407,0,1,1,9.407-9.407A9.407,9.407,0,0,1,11.288,20.695Z",
    fill: "#fc7886"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCrossCircle);
export default __webpack_public_path__ + "static/media/fi-rr-cross-circle.62a3f232.svg";
export { ForwardRef as ReactComponent };